import _sfc_main from "./component-library218.mjs";
import "./component-library219.mjs";
import normalizeComponent from "./component-library91.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "dropdown-item-content" }, [_vm._t("before"), _c("div", { staticClass: "dropdown-item-content__label", class: { "dropdown-item-content__label--break": _vm.breakText } }, [_vm._t("default", function() {
    return [_c("span", { domProps: { "innerHTML": _vm._s(_vm.label) } })];
  })], 2), _setup.hasCount ? _c("span", { staticClass: "dropdown-item-content__count", attrs: { "data-nosnippet": "" } }, [_vm._v(" " + _vm._s(_vm.count) + " ")]) : _vm._e(), _c("span", { staticClass: "dropdown-item-content__indicator", class: { "dropdown-item-content__indicator--active": _vm.selected } })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const DropdownItemContent = __component__.exports;
export {
  DropdownItemContent as default
};
